export var OnboardingSteps;
(function (OnboardingSteps) {
    OnboardingSteps["MARKETING_DATA"] = "MARKETING_DATA";
    OnboardingSteps["FEATURES"] = "FEATURES";
})(OnboardingSteps || (OnboardingSteps = {}));
/** Non-policy choices on the onboarding features step. Stored alongside policy types in `onboarding_features_selected_list`. */
export var OnboardingExtraFeature;
(function (OnboardingExtraFeature) {
    /** Manual one-off actions only */
    OnboardingExtraFeature["ONE_OFF"] = "one_off";
    /** Something not listed */
    OnboardingExtraFeature["OTHER"] = "other";
    /** No automations yet */
    OnboardingExtraFeature["NONE"] = "none";
})(OnboardingExtraFeature || (OnboardingExtraFeature = {}));
//# sourceMappingURL=organisation.js.map